// Vendors
import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Handlers
import { GetStateHandlers } from 'containers/get-state/handlers/get-state.handlers';

const useGetStateHook = (): void => {
  const { showBoundary: setError } = useErrorBoundary();

  const { setCurrentState } = useAppContextConsumerHook();

  const { handleGetCurrentOnboardingCheckoutState } = GetStateHandlers({
    setCurrentState,
    setError,
  });

  useEffect(() => {
    handleGetCurrentOnboardingCheckoutState();
  }, []);
};

export { useGetStateHook };
